import { useCallback, useSyncExternalStore } from 'react';

/**
 * Viewport width (px) at or below which the slot picker stacks calendar and time slots vertically.
 * Must match the `@media (max-width: 640px)` block in `date-time-picker.scss`.
 */
export const SLOT_PANEL_COMPACT_MAX_WIDTH = 640;

/**
 * Returns `true` while the viewport is at most `maxWidth` pixels wide, re-rendering on change.
 * Uses `matchMedia` so it follows the same rule as the stylesheet media query.
 */
export function useCompactViewport(maxWidth: number = SLOT_PANEL_COMPACT_MAX_WIDTH): boolean {
  const query = `(max-width: ${maxWidth}px)`;

  const subscribe = useCallback(
    (onChange: () => void) => {
      const mediaQueryList = window.matchMedia(query);
      mediaQueryList.addEventListener('change', onChange);
      return () => mediaQueryList.removeEventListener('change', onChange);
    },
    [query]
  );

  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false
  );
}
